<template>
  <div
    class="subscribe"
    :class="[theme]"
  >
    <div class="md-layout md-alignment-center-center">
      <h1>KAB21 is on the way</h1>
    </div>
    <div class="md-layout md-alignment-center-center">
      <p class="paragraph">
        Subscribe to receive updates and be the first to know
      </p>
    </div>
    <div class="md-layout md-alignment-center-center subcribe-form"> 
      <div class="form-container">
        <md-field>
          <md-icon>email</md-icon>
          <md-input
            v-model.trim="$v.formData.email.$model"
            placeholder="Email"
            required
          />
        </md-field>
        <div
          v-if="$v.formData.email.$error && !$v.formData.email.required"
          class="md-layout md-alignment-left-center error"
        >
          Email is required
        </div>
        <div
          v-if="$v.formData.email.$error && !$v.formData.email.email"
          class="md-layout md-alignment-left-center error"
        >
          Invalid Email
        </div>
      </div>
      <md-button
        class="md-primary subscribe-button"
        @click="submitForm"
      >
        Subscribe
      </md-button>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: "Subscribe",
  props: {
    theme: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      formData: {
        webform_id: "newsletter",
        email: "", 
      }
    }
  },
  validations: {
    formData: {
      email: { required, email }
    }
  },
  methods: {
    async submitForm () {
      const toast = this.$toasted.show('Saving')
      try {
        this.$v.$touch()
        if (this.$v.$invalid) {
          toast.goAway(0)
          return
        }
        const result = await this.$store.dispatch('webformSubmit',  this.formData)
        console.log(result)
        if (Object.keys(result.data)) {
          this.$store.commit('setErrors', {})
          toast.text('Success').goAway(5000)
        }
      } catch (error) {
        toast.goAway(0)
        this.$toasted.error('Unable to save information').goAway(5000)
        throw error(error)
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.subscribe {
  width: 100%;
  min-height: 223px;
  h1 {
    margin-top: 60px;
    margin-bottom: 1px;
    font-size: 50px; 
    text-align: center;
    color: #000000;
  }
  &.accent {
    h1, .paragraph {
      color: $color-white !important;
    }
    .subscribe-button {
      color: $color-primary !important;
      background-color: $color-white !important;
      background-image: none;
    }
    .error { 
      color: $color-white;
    }
  }
}

.paragraph {
  font-size: 14px;
  line-height: 1.5;
  color: $color-black;
  text-align: center;
  margin-bottom: 20px;
}

.subscribe-button { 
  width: 159px;
  height: 44px;
  background-color: $color-primary !important;
  color: $color-white !important;
  font-weight: 500;
  font-size: 12px;
  border-radius: 4px;
  background-image: linear-gradient(to left, #a30078, #6a0043);
}

.form-container { 
  width: 406px;
  height: 40px;
  padding: 11px;
  background-color: #ffffff;
  margin-right: 30px;
  .md-field {
    position: relative;
    top: -25px;
    input {
      &:focus {
        opacity: 1;
        &::placeholder {
          color: transparent;
        }
      }
      &::placeholder {
        color: #c2d1d9 !important;
        font-size: 14px;
      }
    }
    .md-icon {
      color: $color-primary;
    }
    &:before {
      background-color: initial !important;
    }
    &:after {
      background-color: initial !important;
    }
    &.md-focused {
      &:before {
        background-color: initial !important;
      }
      &:after {
        background-color: initial !important;
      }
    }
  }
  .error {
    position: relative;
    top: -40px;
    color: $color-primary;
    margin-bottom: -20px;
  }
}

@media only screen and (max-width: 600px) {
  .subscribe {
    h1 {
      font-size: 30px;
    }
  }
}

@media only screen and (max-width: 375px) {
  .subscribe {
    h1 {
      font-size: 25px;
    }
  }
}

@media only screen and (max-width: 360px) {
  .subscribe {
    h1 {
      font-size: 25px;
    }
  }
}

@media only screen and (max-width: 320px) {
  .subscribe {
    h1 {
      font-size: 22px;
    }
  }
}

@media only screen and (max-width: 832px) and (orientation: landscape) {
  .subscribe {
    h1 {
      font-size: 40px;
    }
  }
}

</style>
